import React from "react";
import { Button } from "@mui/material";
import DataTable from "../../../lib/components/DataTable";

const UsersDataTable = ({ data = [], isLoading, onActivate, onDeactivate, page, pageSize, totalPages, onPageChange, onPageSizeChange }) => {
  if (isLoading) return null;

  /* -------------------------------------------------------------------------- */
  /* Columns                                                                    */
  /* -------------------------------------------------------------------------- */

  const columns = [
    {
      key: "name",
      header: "Name",
      render: (_, row) => `${row?.firstName ?? ""} ${row?.lastName ?? ""}`,
    },
    {
      key: "email",
      header: "Email",
    },
    {
      key: "status",
      header: "Status",
      type: "status",
    },
  ];

  /* -------------------------------------------------------------------------- */
  /* Status Config                                                              */
  /* -------------------------------------------------------------------------- */

  const statusConfig = {
    ACTIVE: {
      label: "Active",
      className: "badge rounded-pill fw-medium fs-sm bg-primary text-primary bg-opacity-25",
    },
    INACTIVE: {
      label: "Inactive",
      className: "badge bg-danger text-danger rounded-pill fw-medium fs-sm bg-opacity-25",
    },
  };

  /* -------------------------------------------------------------------------- */
  /* Row Actions (conditional render – ORIGINAL BEHAVIOR)                        */
  /* -------------------------------------------------------------------------- */

  const rowActions = {
    actions: [
      {
        render: (row) =>
          row.status === "ACTIVE" ? (
            <Button variant="outlined" color="error" onClick={() => onDeactivate(row, "DEACTIVATE")}>
              Deactivate
            </Button>
          ) : (
            <Button variant="outlined" color="secondary" onClick={() => onActivate(row, "ACTIVATE")}>
              Make Active
            </Button>
          ),
      },
    ],
  };

  return (
    <DataTable
      data={data}
      columns={columns}
      statusConfig={{ status: statusConfig }}
      rowActions={rowActions}
      selectable={false}
      isLoading={isLoading}
      getRowId={(row) => row.id}
      page={page}
      pageSize={pageSize}
      totalPages={totalPages}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
};

export default UsersDataTable;
